import React, { useEffect, useState } from 'react';
import DefaultModal from '../defaultModal/DefaultModal';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import useTranslation from '../../../../hooks/translation/useTranslation';
import {
  addTicketAdditionalServices,
  getTicketAdditionalServices,
} from '../../../../../services/customer/ticketServices';
import PurchaseAdditionalServices from './components/PurchaseAdditionalServices';
import PurchasedAdditionalServices from './components/PurchasedAdditionalServices';
import { bankTypeToCountry } from '../../../../../utils/constants';

function TicketAdditionalServicesModal() {
  const { trans } = useTranslation();
  const { configInfo } = useTranslation();
  const {
    showTicketAdditionalServicesModal,
    setShowTicketAdditionalServicesModal,
  } = useModal();

  const [
    additionalServiceDetails,
    setAdditionalServiceDetails,
  ] = useState({});

  useEffect(() => {
    const fetchServices = async () => {
      const res = await getTicketAdditionalServices(showTicketAdditionalServicesModal.data);
      if (res.status === 'success') {
        setAdditionalServiceDetails(res.data);
      }
    };
    if (showTicketAdditionalServicesModal.show) {
      fetchServices();
    }
  }, [showTicketAdditionalServicesModal.show]);

  const purchaseAdditionalService = async (service) => {
    const bank_type = bankTypeToCountry?.[configInfo?.countryCode];
    const res = await addTicketAdditionalServices({
      ticketId: showTicketAdditionalServicesModal.data.ticket_id,
      statement_id: showTicketAdditionalServicesModal.data.statement_id,
      services: [{
        amount: service.amount,
        quantity: 1,
        serviceId: service.serviceId,
        tariffMultiplyValueId: 1,
      }],
      ...(bank_type && {
        bank_type,
      }),
    });
    if (res.status === 'success') {
      window.location.replace(res.payment_url);
    }
  };

  return (
    <DefaultModal
      width="629px"
      show={showTicketAdditionalServicesModal?.show}
      setShow={setShowTicketAdditionalServicesModal}
      className="ticket-refund-modal"
    >
      <div className="flex flex-col gap-5">
        <h2
          className="font-big-bold m-0"
        >
          {trans('additional_services')}
        </h2>
        <PurchasedAdditionalServices
          purchasedAdditionalServices={additionalServiceDetails?.ticket_additional_services}
        />
        <PurchaseAdditionalServices
          additionalServices={additionalServiceDetails?.ride_additional_services}
          purchaseAdditionalService={purchaseAdditionalService}
        />
      </div>
    </DefaultModal>
  );
}

export default TicketAdditionalServicesModal;
